import { render, staticRenderFns } from "./IntermediaryMapping.vue?vue&type=template&id=cb6f45c2&scoped=true&"
import script from "./IntermediaryMapping.vue?vue&type=script&lang=js&"
export * from "./IntermediaryMapping.vue?vue&type=script&lang=js&"
import style0 from "./IntermediaryMapping.vue?vue&type=style&index=0&id=cb6f45c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6f45c2",
  null
  
)

export default component.exports